module.exports = __webpack_public_path__ + "89393271cb1761ad27e913a3ed31e43f.pdf";